import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;

  .section {
    margin-left: 15px;
  }

  .tools_bar {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
  }
  .search_input {
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
    width: 60%;
    margin: 20px 0 0;
  }
  .register_button {
    background-color: rgba(0, 0, 0, 0.1);
    margin: 20px 2% 0;
  }

  .station_details {
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
    width: 66%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 12px;

    p {
      margin: 3px 0;
      font-size: 12px;
      width: max-content;
    }

    .strong {
      font-weight: 600;
      grid-column: 1 / 1;
    }

    .label1 {
      grid-row: 1;
      grid-column: 1 / -1;
    }

    .value1 {
      grid-row: 2;
      grid-column: 2;
    }
    .value2 {
      grid-row: 3;
      grid-column: 2;
    }
    .value3 {
      grid-row: 4;
      grid-column: 2;
    }
  }

  .button_station {
    margin-top: 6px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 8px;
    width: 170px;
    display: block;
    padding: 10px 0 10px 0;
    text-align: center;
    line-height: 1em;
    text-decoration: none;
    justify-content: space-between;
    font-size: 13px;
    transition: background-color 200ms ease-in-out;
    background-color: rgba(0, 0, 0, 0.05);
    color: #555;

    p {
      margin: 0 0 0 6px;
    }

    :hover path {
      fill: ${COLORS.primary};
    }

    :hover {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }
  }

  .delete_station {
    background-color: ${COLORS.red};
    color: ${COLORS.white};

    :hover path {
      fill: #ff7d7d;
    }

    :hover {
      background-color: #ff7d7d;
      color: #ffd6d6;
    }
  }

  .chart {
    background-color: #fff;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 20px 20px 100px 45px;
    max-width: 350px;
    width: 27%;
    height: calc(100% - 20px);
    margin: 0 auto;
    opacity: 0;
  }

  .qrcode {
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-right: 12px;
  }

  .qrcodes-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
    flex-wrap: nowrap;
  }
  .qrcode-container,
  .qrcode-container-terminal {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;

    .button_station {
      width: 110px;
      padding: 6px 0;
      font-size: 11px;
      margin-top: 4px;
    }
  }

  .station_id {
    margin: 0;
    padding: 0;
    text-align: center;
    color: black;
  }
`;

export const ModalButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
